import React from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
    text-align: center;
    grid-column: 1/-1;
`

const NoGridData = () => {
    return <StyledDiv>No data</StyledDiv>
}

export default NoGridData
